import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Navigation,
  useNavigationToggle,
} from "@coherence-design-system/navigation";
import { INavLink } from "@coherence-design-system/navigation";
import { useLocation } from "react-router-dom";
import navGroups from "../navGroups.json";
import { checkForPermission } from "../../utils/checkForPermission";
import { APP_SETTINGS } from "../../config/config";

const navGroupFlyoutStyles = (p: any) =>
  p?.isNavCollapsed && !p?.isCollapsibleSection
    ? {
      nestedNav: { background: "var(--nav-flyout-strip, #e6e6e6)" },
      nestedNavHeaderItem: { backgroundColor: "var(--nav-flyout-header, #cfcfcf)" },
      nestedNavLinks: { backgroundColor: "var(--nav-flyout-list, #ffffff)" },
    }
    : {};

const AppNavigation = (props: IAppNavigationProps) => {
  const { toggleNavCollapsed } = useNavigationToggle();
  const { isNavMenuExpended } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (
    key: string,
    path: string,
    event?: React.MouseEvent<HTMLElement, MouseEvent>,
    item?: INavLink
  ) => {
    if (event) event.preventDefault();
    if (path !== "#") {
      navigate(path);
    }
  };

  const groups = navGroups.map((group) => ({
    ...group,
    links: group.links
      .filter((link) => {
        return APP_SETTINGS.MENU_ITEM_PERMISSION[link.key]
          ? checkForPermission(
            "MenuItem",
            link.key
          )
          : true;
      })
      .map((link) => ({
        ...link,
        navLinkGroupStyles: navGroupFlyoutStyles,
        onClick: (
          e: React.MouseEvent<HTMLElement, MouseEvent> | undefined,
          item: INavLink | undefined
        ) => handleNavigation(link.key, link.href, e, item),
        isSelected: link.href !== "#" && location.pathname === link.href,
        links: link.links?.filter((subLink) => {
          return APP_SETTINGS.MENU_ITEM_PERMISSION[subLink.key]
            ? checkForPermission(
              "MenuItem",
              subLink.key
            )
            : true;
        }).map((subLink) => ({
          ...subLink,
          onClick: (
            e: React.MouseEvent<HTMLElement, MouseEvent> | undefined,
            item: INavLink | undefined
          ) => handleNavigation(subLink.key, subLink.href, e, item),
                    isSelected: (() => {
            if (!subLink.href.includes("?")) {
              // Plain path — match on pathname only
              return location.pathname === subLink.href || location.pathname.startsWith(subLink.href + "/");
            }
            // Path with query params (e.g. lab inventory tools) — match pathname
            // AND the discriminating tool id query param. The list page uses
            // "sourceToolId" while details/edit/checkout-summary pages use
            // "toolId" for the same tool, so check both.
            const linkUrl = new URL(subLink.href, window.location.origin);
            const linkToolId = linkUrl.searchParams.get("sourceToolId");
            const currentParams = new URLSearchParams(location.search);
            const currentToolId = currentParams.get("sourceToolId") ?? currentParams.get("toolId");

            const pathnameMatches =
              location.pathname === linkUrl.pathname ||
              location.pathname.startsWith(linkUrl.pathname + "/");

            return pathnameMatches && (linkToolId === null || currentToolId === linkToolId);
          })(),
        })),
      })),
  }));

  return (
    <React.Fragment>
      <Navigation
        groups={groups}
        isNavCollapsed={isNavMenuExpended}
        toggleNavCollapsed={toggleNavCollapsed}
        styles={{
          navContainer: {
            background: "var(--card-background,#eef0f1)",
            height: "93%",
          },
         navWrapper: {
            height: "99%",
          },
          // link: {
          // 	color: "var(--menu-text)",
          // },
          // linkHovered: {
          //   backgroundColor: "var(--menu-hover)",
          // }
        }}
      />
    </React.Fragment>
  );
};

export default AppNavigation;
